import React from 'react';

import { BlockComponentModel } from '@/components/cms/types/blok-component';

import { Divider, DividerProps } from '.';

export interface DividerSBProps {
  alignment?: DividerProps['alignment'];
}

export default function DividerSB({
  block,
}: BlockComponentModel<DividerSBProps>) {
  return <Divider {...block} />;
}
